import React, { useState, useEffect ,useMemo} from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button,Box,  } from "@material-ui/core";
import HelpBlockImg from "../../_assets/_images/helpBlock.png";
import Paper from "@material-ui/core/Paper";
import { history } from '../../_redux/_store/history'
import queryString from 'query-string'
import { useSelector, useDispatch } from "react-redux";
import { clearAnomalySearchFilter, clearCurrentSignals } from '../../_redux/_actions/anomalyRuleActions';
import {clearSpecificAnomalyRule} from "../../_redux/_actions/selectScopedAnomalyRuleAction"
import BreadcrumbDispatch from "../../_partials/breadcrumbDispatch";
import { Select,MenuItem,InputLabel} from '@material-ui/core';
import {fetchMachineType} from "../../_redux/_actions/scopedMenuAction";
import {fetchAnomalyHMI} from "../../_redux/_actions/scopedAnomalyRuleActions"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    height:'100%',
    padding: theme.spacing(2),
  },
  itemBoxHeading: {
    height: '50px',
    minHeight: '100px'
  },
  itemBoxSubHeading: {
    fontWeight: "bold",
    marginTop: 50,
    fontSize: 14,
    height:'20px'
  },
  itemBoxList:{
    marginTop: 20,
    height:'100px'
  },
  selector:{
    marginTop:'10px'
  }
}));

const Landing = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues;
  const [machineType, setMachineType] = useState(machine_type || '');
  const [hmiType, setHMIType] = useState(hmi_type || '');

  const machineTypes = useSelector(
    (state) => state.selectMenuData.selectMachineTypes
  );

  const anomalyResponse = useSelector(
    (state) => state.scopedAnomalyRule
  )

  useEffect(() => {
    return () => {
     dispatch(clearCurrentSignals());
    };
  }, []);

  useEffect(() => {
    dispatch(fetchMachineType())
    dispatch(clearAnomalySearchFilter());
    dispatch(clearSpecificAnomalyRule())
    if(machineType){
      dispatch(fetchAnomalyHMI({ machine_type: machineType}));
    }
  }, []);

  const handleMachineTypeChange = (event) => {
   setMachineType(event.target.value);
   setHMIType('')
   history.replace({ pathname: '/rules', search: `?machine_type=${event.target.value}&hmi_type=`});
   dispatch(fetchAnomalyHMI({ machine_type: event.target.value}));
  };

  const handleHMITypeChange = (event) =>{
    setHMIType(event.target.value)
    history.replace({ pathname: '/rules', search: `?machine_type=${machine_type}&hmi_type=${event.target.value}`});
  }

  return (
    <Grid container className="landingPage">
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item md={9}>
            <Paper className={classes.control}>
              <Grid container direction="row" justifyContent="space-between">
                <Grid item md={6}>Please select any workflow from the following to continue</Grid>
                <Grid container md={6} direction="row" style={{justifyContent:"end"}}>
                  <Grid item md={5} sm={5} lg={5}>
                    <InputLabel id="demo-multiple-name-label">Machine Type</InputLabel>
                     {machineTypes && <Select
                      fullWidth
                      id='machineSelector'
                      className={classes.selector}
                      variant='outlined'
                      placeholder="Machine Type"
                      value={machineType || ""}
                      onChange={(event) =>
                        handleMachineTypeChange(event)
                      }
                      MenuProps={{
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      {machineTypes?.map((item) => {
                        return(
                          <MenuItem
                            id={item}
                            value={item}
                            key={`${item}`}
                          >
                            {item}
                          </MenuItem>
                       )
                      })}
                    </Select>
                    }
                  </Grid>
                  <Grid item md={5} sm={5} lg={5} style={{marginLeft:'10px'}}>
                    <InputLabel id="demo-multiple-name-label">HMI Type</InputLabel>
                    {anomalyResponse.hmi && <Select
                      fullWidth
                      className={classes.selector}
                      value={hmiType || ""}
                      placeholder="HMI Type"
                      id='hmiSelector'
                      variant='outlined'
                      displayEmpty
                      onChange={(event) =>
                        handleHMITypeChange(event)
                      }
                      MenuProps={{
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                      }}
                    >
                      {anomalyResponse.hmi && anomalyResponse.hmi.map((item) => {
                        return(
                          <MenuItem
                            id={item}
                            value={item}
                            key={`${item}`}
                          >
                            {item}
                          </MenuItem>
                       )
                      })}
                    </Select>
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2} className="containerWrapper" style={!machineType || !hmiType ? { opacity: 0.5, pointerEvents:'none' } : {}}>
               <Grid item md={4}>
                  <Paper className="itemBox">
                    <div className="itemBoxHeader">Finding Rule</div>
                    <div className="itemBoxContent">
                    <p className="itemBoxHeading">
                        The finding rule configuration UI can be used to create,
                        edit or delete finding rules. It can also be used to
                        configure finding rules per scope by setting :
                      </p>
                      <p
                      className={classes.itemBoxSubHeading}
                      >
                        Key Operations
                      </p>
                      <ul className={classes.itemBoxList}>
                        <li>
                          Triggering Operation (Boolean expression from
                          anomalies)
                        </li>
                        <li>Set Ranked Recommendation</li>
                      </ul>
                      <Button onClick={() => {history.push(`/rules/select_finding_rule?machine_type=${machineType}&hmi_type=${hmiType}`)}} className="btn-primary" > Select</Button>
                    </div>
                  </Paper>
                </Grid>
                <Grid item md={4}>
                  <Paper className="itemBox">
                    <div className="itemBoxHeader">Anomaly Rule</div>
                    <div className="itemBoxContent">
                      <p className="itemBoxHeading">
                        Anomaly Rule UI lets you Create Edit Delete anomaly
                        rule. Scoped Anomaly rules, parameters can be edited.
                      </p>
                      <p
                        className={classes.itemBoxSubHeading}
                      >
                        Key Operations
                      </p>
                      <ul className={classes.itemBoxList}>
                        <li>Create or Search Anomaly Rule</li>
                        <li>Edit Anomaly Rule</li>
                        <li>Delete Anomaly Rule</li>
                      </ul>
                      <Button onClick={() => {history.push(`/rules/select_anomaly_rule?machine_type=${machineType}&hmi_type=${hmiType}`)}} className="btn-primary" > Select</Button>
                    </div>
                  </Paper>
                </Grid>
                <Grid item md={4}>
                  <Paper className="itemBox">
                    <div className="itemBoxHeader">Recommendations</div>
                    <div className="itemBoxContent">
                    <p className="itemBoxHeading">
                        Recommendations UI panel can be used to create / edit /
                        delete Recommendations from the database. Later these
                        recommendations can be accessed in the Anomaly
                        Configuration.
                      </p>
                      <p
                      className={classes.itemBoxSubHeading}
                      >
                        Key Operations
                      </p>
                      <ul className={classes.itemBoxList}>
                        <li>Create / Search Recommendations</li>
                        <li>Edit / Delete Recommendation</li>
                      </ul>
                      <Button onClick={() => {history.push(`/rules/select_recommendation?machine_type=${machineType}&hmi_type=${hmiType}`)}} className="btn-primary" > Select</Button>
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item md={3} className="helpBlock">
            <Paper className={classes.control}>
            <Box component="div" className="helpBlockTitle">
                Help
            </Box>
            <br />
            <p>
              How to get started?
            </p>
            <br />
            <p>Step 1: Select the desired work flow from the given options below.</p>
            <br />
            <p>
               Step 2: Start configuring selected workflow after selection
            </p>
            <br />
            <Grid container alignItems="flex-end">
            <Box component="div">
              <img
                src={HelpBlockImg}
                alt="HelpBlockImg"
                className="img-fluid"
              />
            </Box>
            </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Landing;
